export class AccountType {
    static CUSTOMER = 1;
    static PROVIDER = 2;
}

Object.freeze(AccountType);